import {useEffect} from 'react'
import {BuyoutModalFormWrapper} from './BuyoutModalFormWrapper'
import {BuyoutModalHeader} from './BuyoutModalHeader'

const BuyoutModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_buyout'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-1000px'>
          {/* begin::Modal content */}
          <div className='modal-content    CreateWebsite__overflow-container'>
            {/* begin::Modal body */}
            <BuyoutModalHeader />
            <div className='modal-body scroll-y '>
              <BuyoutModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {BuyoutModal}
